import React, { useState, useEffect } from 'react';
import ComejoinCard from '../about/comeJoin/ComejoinCard';
import './OfferingLast.css';
import { images } from '../../assets';

function OfferingLast() {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const data = {
        id: 1,
        heading: "Want to know more about the offerings?",
        img: windowWidth <= 821 ? images.offeringBgMobile : images.offeringBg, // Check window width here
        button: "Talk to Expert",
    };

    const customClass = {
        comejoin: "offeringLast",
        comejoincomp: "offeringLastcomp",
        comejoincard: "offeringLastcard",
        comejoincontent: "offeringLastcontent",
        comejoinheading: "offeringLastheading",
        comejoindesc: "offeringLastdesc",
        comejoinbutton: "offeringLastbutton",
        seeoppurtunities: "seeoppurtunities",
    };

    return <ComejoinCard className={customClass} data={data} />;
}

export default OfferingLast;
